var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex mb-2" },
        [
          _c("h4", [_vm._v("Подробная статистика по часам")]),
          _vm._v(" "),
          _vm.loading ? _c("b-spinner", { staticClass: "mb-2 ml-3" }) : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-table",
        _vm._b(
          {
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.mainSlots, function(slot) {
                  return {
                    key: "FOOT_" + slot,
                    fn: function(data) {
                      return [
                        _c(
                          "div",
                          { key: slot },
                          [
                            _c(
                              "b-table",
                              _vm._b(
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "HEAD_stats",
                                        fn: function(data) {
                                          return [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between"
                                              },
                                              [
                                                _c("span", [_vm._v("Кол-во")]),
                                                _c("span", [_vm._v("Сумма")])
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "title",
                                        fn: function(data) {
                                          return [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(data.value) +
                                                _vm._s(
                                                  data.item.stats.avg !==
                                                    undefined
                                                    ? ": " + data.item.stats.avg
                                                    : ""
                                                ) +
                                                "\n          "
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "stats",
                                        fn: function(data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(data.value.count)
                                                  )
                                                ]),
                                                _c("span", [
                                                  _vm._v(_vm._s(data.value.sum))
                                                ])
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "percent",
                                        fn: function(data) {
                                          return [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  data.item.stats.percent
                                                    ? data.item.stats.percent.toFixed(
                                                        2
                                                      )
                                                    : ""
                                                ) +
                                                "\n          "
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                "b-table",
                                _vm.innerTableProps(
                                  _vm.workshopFormatter(
                                    _vm.reduceSummaryStats(data.column)
                                  )
                                ),
                                false
                              )
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                }),
                {
                  key: "FOOT_total",
                  fn: function(data) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "b-table",
                            _vm._b(
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "HEAD_stats",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "strong",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between"
                                            },
                                            [
                                              _c("span", [_vm._v("Кол-во")]),
                                              _c("span", [_vm._v("Сумма")])
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "title",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(data.value) +
                                              _vm._s(
                                                data.item.stats.avg !==
                                                  undefined
                                                  ? ": " + data.item.stats.avg
                                                  : ""
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "stats",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(data.value.count))
                                              ]),
                                              _c("span", [
                                                _vm._v(_vm._s(data.value.sum))
                                              ])
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "percent",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                data.item.stats.percent
                                                  ? data.item.stats.percent.toFixed(
                                                      2
                                                    )
                                                  : ""
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              "b-table",
                              _vm.innerTableProps(_vm.sumTotalStats()),
                              false
                            )
                          )
                        ],
                        1
                      )
                    ]
                  }
                },
                _vm._l(_vm.mainSlots, function(slot) {
                  return {
                    key: slot,
                    fn: function(data) {
                      return [
                        _c(
                          "div",
                          { key: slot },
                          [
                            _c(
                              "b-table",
                              _vm._b(
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "HEAD_stats",
                                        fn: function(data) {
                                          return [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between"
                                              },
                                              [
                                                _c("span", [_vm._v("Кол-во")]),
                                                _c("span", [_vm._v("Сумма")])
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "title",
                                        fn: function(data) {
                                          return [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(data.value) +
                                                _vm._s(
                                                  data.item.stats.avg !==
                                                    undefined
                                                    ? ": " + data.item.stats.avg
                                                    : ""
                                                ) +
                                                "\n          "
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "stats",
                                        fn: function(data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(data.value.count)
                                                  )
                                                ]),
                                                _c("span", [
                                                  _vm._v(_vm._s(data.value.sum))
                                                ])
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "percent",
                                        fn: function(data) {
                                          return [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  data.item.stats.percent
                                                    ? data.item.stats.percent.toFixed(
                                                        2
                                                      )
                                                    : ""
                                                ) +
                                                "\n          "
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                "b-table",
                                _vm.innerTableProps(data.value),
                                false
                              )
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                })
              ],
              null,
              true
            )
          },
          "b-table",
          _vm.statsTableProps,
          false
        ),
        [
          _c(
            "div",
            {
              staticClass: "text-center",
              attrs: { slot: "table-busy" },
              slot: "table-busy"
            },
            [_c("strong", [_vm._v("Загрузка статистики...")])]
          ),
          _vm._v(" "),
          _c("template", { slot: "FOOT_datetime" }, [
            _vm._v("\n      Итого:\n    ")
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ce42910", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ce42910","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableDetailedStatsWorkshop.vue
// module id = null
// module chunks = 